module.exports = "<span class=\"checkbox js-toggle-button\"> <span class=\"svg-icons-wrp svg-icons-wrp_checked\"> <svg class=\"svg-icons svg-icons_checked\"><use xlink:href=#icon-checked /> </svg> </span> </span> <span class=\"checkbox-text js-display-text\">{{#if displayHtml}}{{{displayHtml}}}{{else}}{{displayText}}{{/if}}</span> ";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/templates/booleanEditor.hbs
// module id = 682
// module chunks = 0